import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { Card, Alert } from "reactstrap";
import Layout from "../../components/Wrappers/Layout";
import BackButton from "../../components/BackButton/BackButton";
import { useSelector, useDispatch } from "react-redux";
import {
	resetAddNewWalletForCustomerList,
	addNewWalletForCustomerList
} from "../../redux/actions/addNewWalletForCustomerAction";
import { getAllWalletsList } from "../../redux/actions/getAllWalletsListAction";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
// import Tooltip from "@mui/material/Tooltip";
// import EditIcon from "@mui/icons-material/Edit";
// import { makeStyles } from "@mui/styles";
import { makeStyles } from "@mui/styles";

import LoadingSpinner from "../../components/LoadingSpinner/spinner.css";
import "../../components/LoadingSpinner/spinner.css";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

//new
import {
	getRegenerateToken,
	resetRegenerateToken,
  } from "../../redux/actions/regenerateTokenAction";
  

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const FeeWallet = () => {
	const [notificationOpen1, setNotificationOpen1] = useState(false);
	const [isLoading, setIsLoading] = useState(false);
	const classes = useStyles();
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);
	const [currency, setcurrency] = useState("");
	const [notificationOpen, setNotificationOpen] = useState(false);
	const [walletName, setwalletName] = useState("");
	const dispatch = useDispatch();
	const [addNewWalletForCustomer, setaddNewWalletForCustomer] =
		React.useState(false);

	const [addNewWalletForCustomerResArray, setaddNewWalletForCustomerResArray] =
		useState("");

	const [getAllWalletsListStatus, setgetAllWalletsListStatus] = useState(false);
	const [getAllWalletsListResArray, setgetAllWalletsListResArray] =
		useState("");

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const adminCurrencyLists = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);


    const login = useSelector(({ login }) => login);
	console.log("Login data" , login.data.customerId);

	const addNewWalletForCustomerRes = useSelector(
		({ addNewWalletForCustomer }) => addNewWalletForCustomer
	);

	// const getAllWalletsListRes = useSelector(
	//     ({ getAllWalletsList }) => getAllWalletsList
	// );

	const handleNoticationClose = () => {
		if (notificationOpen1) {
			setNotificationOpen1(false);
		}
		setNotificationOpen(false);
	};

	// console.log("getAllWalletsListRes", getAllWalletsListRes);
	// console.log("getAllWalletsListRes", getAllWalletsListRes);

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const handleChange = ({ target: { name, value } }) => {
		if (name === "currency") {
			setcurrency(value == "Select Currency" ? "" : value);
		}

		if (name === "walletName") {
			// setwalletName(value);
			Util.verifyAlphabet(value)
				? setwalletName(value)
				: setwalletName(walletName);
		}
	};

	const addNewWalletForCustomerApi = () => {
		if (walletName != "" && currency != "") {
			setaddNewWalletForCustomer(true);
			const getAllWalletsListReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerId: login.data.customerId,
					storeId: login.data.storeId,
					walletType: "owner",
					currency: currency,
					walletName: walletName
				}
			};

			dispatch(addNewWalletForCustomerList(getAllWalletsListReq, authToken));
		} else {
			setNotificationOpen1(true);
		}
		// if(addNewWalletForCustomerRes.data.status)
	};

	// console.log('Test useState State: ', addNewWalletForCustomerRes);
	const addNewWalletForCustomerFunc = () => {
		if (addNewWalletForCustomer) {
			if (addNewWalletForCustomerRes.data.status == "success") {
				setNotificationOpen(true);
				setaddNewWalletForCustomerResArray(addNewWalletForCustomerRes.data.status);
				// getAllWalletsListApi();
			}
			if (addNewWalletForCustomerRes.data.status == "failed") {
				setNotificationOpen(true);
				// getAllWalletsListApi();
				setaddNewWalletForCustomerResArray(
					addNewWalletForCustomerRes.data.status
				);
				if (
					addNewWalletForCustomerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addNewWalletForCustomerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}

			if (addNewWalletForCustomerRes.data.status == "Failed") {
				setNotificationOpen(true);
				// getAllWalletsListApi();
				setaddNewWalletForCustomerResArray(
					addNewWalletForCustomerRes.data.status
				);
				if (
					addNewWalletForCustomerRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					addNewWalletForCustomerRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	const getAllWalletsListApi = () => {
		setIsLoading(true);
		setgetAllWalletsListStatus(true);
		const getAllWalletsListReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				customerId: "",
				customerName: "",
				currency: "",
				walletType: "owner"
			}
		};

		return dispatch(getAllWalletsList(getAllWalletsListReq, authToken));
	};

	// useEffect(() => {
	//   getAllWalletsListApi();
	// }, [])

	useEffect(() => {
		addNewWalletForCustomerFunc();
	}, [addNewWalletForCustomerRes.data.status]);

	return (
		<>
			<Layout>
				<BackButton />
				<Card>
					{/* <BackButton /> */}
					<Grid item xs={12} md={0} lg={0}></Grid>
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								required
								select
								autoFocus
								margin="dense"
								id="name"
								label="Currency"
								fullWidth
								variant="standard"
								type="text"
								name="currency"
								defaultValue={"Select Currency" || currency}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Currency" selected="Select Currency">
									Select Currency
								</MenuItem>
								{adminCurrencyLists.success &&
									[]
										.concat(adminCurrencyLists.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>
						</Grid>
						<Grid item xs={12} sm={12} md={4} lg={4}>
							<TextField
								required
								autoFocus
								margin="dense"
								id="name"
								label="Wallet Name"
								type="text"
								fullWidth
								variant="standard"
								name="walletName"
								value={walletName}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid
							item
							xs={12}
							sm={12}
							md={2}
							lg={2}
							container
							style={{
								padding: "10px",
								marginTop: "0.5rem",
								marginBottom: "15px"
							}}
						>
							<Grid>
								<CustomButton
									style={{
										padding: "8px"
									}}
									onClick={addNewWalletForCustomerApi}
								>
									Add Wallet
								</CustomButton>
								{/* <Button
                  style={{
                    marginLeft: "0.7rem",
                    backgroundColor: "#00b9f5",
                    color: "white",
                  }}
                  variant="contained"
                  onClick={addNewWalletForCustomerApi}
                >
                  Add Wallet
                </Button> */}
							</Grid>
							{/* <Grid item md={7}></Grid> */}
						</Grid>
					</Grid>
				</Card>{" "}
				{/* {isLoading ? (
          <LoadingSpinner />
        ) : getAllWalletsListResArray.length == undefined ||
          !getAllWalletsListStatus ? (
          <Card>
            <Grid
              container
              style={{
                padding: "10px",
              }}
            >
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Typography variant="body1" style={{ fontWeight: "700" }}>
                  Wallet List
                </Typography>
              </Grid>
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Alert
                  className="my-3"
                  variant="secondary"
                  style={{ backgroundColor: "#00b9f5", color: "white" }}
                >
                  No Records Found!
                </Alert>
              </Grid>
            </Grid>
          </Card>
        ) : (
          <Card>
            <Grid
              container
              style={{
                padding: "10px",
              }}
            >
              <Grid xs={12} sm={12} md={12} lg={12}>
                <Typography variant="body1" style={{ fontWeight: "700" }}>
                  Wallet List
                </Typography>
              </Grid>
              <TableContainer component={Paper} className="my-3">
                <Table
                  className={classes.table}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead>
                    <TableRow style={{ background: "#00b9f5" }}>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Wallet ID{" "}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Customer/Merchant ID{" "}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Customer/Merchant Name
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Wallet Name
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Currency
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Balance
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ fontWeight: "bold", color: "white" }}
                      >
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {getAllWalletsListResArray &&
                      []
                        .concat(getAllWalletsListResArray)
                        .slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                        .map((row, index) => (
                          <TableRow key={index}>
                            <TableCell align="center">{row.walletId}</TableCell>
                            <TableCell align="center">
                              {row.customerId}
                            </TableCell>
                            <TableCell align="center">{row.custName}</TableCell>
                            <TableCell align="center">
                              {row.walletName}
                            </TableCell>
                            <TableCell align="center">
                              {row.walletCurrency}
                            </TableCell>
                            <TableCell align="center">
                              {row.walletBalance}
                            </TableCell>
                            <TableCell align="center">
                              <Tooltip title="Edit">
                                <CustomButton
                                  style={{
                                    padding: "8px",
                                  }}
                                //   onClick={() =>
                                //     editGetCustomerIdAndName(
                                //       row.walletName,
                                //       row.customerId,
                                //       row.walletId,
                                //       row.walletCurrency,
                                //       row.custName
                                //     )
                                //   }
                                >
                                  {
                                    <EditIcon
                                      style={{
                                        color: "#fff",
                                        fontSize: "20px",
                                      }}
                                    />
                                  }
                                </CustomButton>
                              </Tooltip>
                            </TableCell>
                          </TableRow>
                        ))}
                  </TableBody>
                </Table>
                <TablePagination
                  rowsPerPageOptions={[5, 10, 25]}
                  component="div"
                  count={getAllWalletsListResArray.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onChangePage={handleChangePage}
                  onChangeRowsPerPage={handleChangeRowsPerPage}
                />
              </TableContainer>
            </Grid>
          </Card>
        )} */}
			</Layout>

			{addNewWalletForCustomerResArray.toLowerCase() == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								Wallet Created Successfully
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addNewWalletForCustomerResArray.toLowerCase() == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								{addNewWalletForCustomerRes.data.description === '' ? 'No Data Found' : addNewWalletForCustomerRes.data.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{addNewWalletForCustomerRes.data.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{
									margin: "0 20px",
									fontSize: "15px",
									textAlign: "center"
								}}
							>
								{addNewWalletForCustomerRes.data.description === '' ? 'No Data Found' : addNewWalletForCustomerRes.data.description}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{notificationOpen1 && (
				<div>
					<Dialog open={notificationOpen1} onClose={handleNoticationClose}>
						<DialogContent className="text-center"
						style={{ backgroundColor: "#00b9f51c" }}
						
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h3
								style={{ margin: "0", fontSize: "15px", textAlign: "center" }}
							>
								{addNewWalletForCustomerResArray.description ? addNewWalletForCustomerResArray.description : 'Please Enter Credentials'}
							</h3>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							<CustomButton
								style={{
									padding: "8px 16px"
								}}
								onClick={handleNoticationClose}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default FeeWallet;
